/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from '../conversation/KanbanView.vue';
import CalendarView from '../conversation/CalendarView.vue';
import ManageFunnels from '../conversation/ManageFunnels.vue';
import FunnelSettings from '../conversation/FunnelSettings.vue';
import ContactImport from '../conversation/ContactImport.vue';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import DealRecordView from '../conversation/components/kanban/deal-record/DealRecordView.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS as CONVERSATION_PERMISSION_LIST,
} from 'dashboard/constants/permissions.js';

// Lista oficial (constants/permissions): uma cópia local sem
// conversation_team_manage prendia o grupo Gestor num redirect infinito.
const CONVERSATION_PERMISSIONS = [...ROLES, ...CONVERSATION_PERMISSION_LIST];

export default {
  routes: [
    // Rotas do Pipeline (antes Kanban) - completamente separadas
    {
      path: frontendURL('accounts/:accountId/pipeline'),
      name: 'pipeline_view',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: KanbanView,
      props: () => ({ viewType: 'kanban' }),
    },
    {
      path: frontendURL('accounts/:accountId/pipeline/funnel/:funnelId'),
      name: 'pipeline_funnel_view',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: KanbanView,
      props: route => ({
        viewType: 'kanban',
        funnelId: route.params.funnelId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/pipeline/negocio/:conversationId'),
      name: 'pipeline_deal',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: DealRecordView,
      props: route => ({ conversationId: route.params.conversationId }),
    },
    // Rota do Calendário
    {
      path: frontendURL('accounts/:accountId/pipeline/calendar'),
      name: 'pipeline_calendar',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: CalendarView,
    },
    // Redirect antigo /kanban para /pipeline
    {
      path: frontendURL('accounts/:accountId/kanban'),
      redirect: to => ({
        name: 'pipeline_view',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/funnels/manage'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'manage_funnels',
          meta: {
            permissions: ['administrator'],
          },
          component: ManageFunnels,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/funnels/:funnelId/settings'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'funnel_settings',
          meta: {
            permissions: ['administrator'],
          },
          component: FunnelSettings,
          props: route => ({ funnelId: route.params.funnelId }),
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/contacts/import'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'contact_import',
          meta: {
            permissions: ['administrator'],
          },
          component: ContactImport,
        },
      ],
    },
  ],
};
